import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserActivityService implements OnDestroy {
  
  private readonly INACTIVITY_TIME =   5 * 60 * 1000; // 5 minutos
  private inactivityTimer: any;

  private isUserActive = new BehaviorSubject<boolean>(true);
  public isUserActive$ = this.isUserActive.asObservable();

  constructor(private zone: NgZone) {
    this.initActivityListeners();
    this.resetInactivityTimer(); // inicializa
  }

  private initActivityListeners(): void {
    const activityEvents = ['mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll'];

    activityEvents.forEach(event =>
      window.addEventListener(event, this.resetInactivityTimerBound, true)
    );

    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  private resetInactivityTimerBound = () => this.resetInactivityTimer();
  private handleVisibilityChange = () => this.resetInactivityTimer();

  private resetInactivityTimer(): void {
    if (!this.isUserActive.value) {
      this.isUserActive.next(true); // Marcamos ativo novamente
    }

    clearTimeout(this.inactivityTimer);

    this.inactivityTimer = setTimeout(() => {
      this.markInactive();
    }, this.INACTIVITY_TIME);
  }

  private markInactive(): void {
    if (this.isUserActive.value) {
      this.isUserActive.next(false);
    }
  }

  ngOnDestroy(): void {
    clearTimeout(this.inactivityTimer);
    window.removeEventListener('mousemove', this.resetInactivityTimerBound, true);
    window.removeEventListener('keydown', this.resetInactivityTimerBound, true);
    window.removeEventListener('mousedown', this.resetInactivityTimerBound, true);
    window.removeEventListener('touchstart', this.resetInactivityTimerBound, true);
    window.removeEventListener('scroll', this.resetInactivityTimerBound, true);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  }
}
